import PlayFieldRaceTicket from "./play-field-race-ticket";
import PlayFieldResults from "./play-field-results";
import pure from "./higher-order/pure";
import RaceOverview from "./race-overview";
import React from "react";
import selectPage from "../select-page";
import SurvivorOverview from "./survivor-overview";
import TablePaginationSpacer from "./table-pagination-spacer";

export default pure(function PlayFieldRaceHeader({ bets, myTickets, number, page, pageSize, race, raceEntrants, survivors, tickets, tournament, users }) {
  var overview = <RaceOverview race={race} />;
  if (tournament.get("tournament_type") === "Survivor" && race.get("status") === "final") {
    overview = <SurvivorOverview number={number} survivors={survivors} tournament={tournament} users={users} />;
  }

  return (
    <div className={"game-table game-table--race-status--" + race.get("status")}>
      <div className="game-table_row">
        <div className="game-table_cell game-table_cell--action game-table_cell--race">
          <span className="game-summary_label">
            {number}
          </span>
        </div>

        <div className="game-table_cell game-table_cell--track">
          <span className="game-summary_label">
            {race.get("track_name")}
            -

            {race.get("race_number")}
          </span>
        </div>

        <div className="game-table_cell game-table_cell--overview">
          {overview}
        </div>

        <PlayFieldResults bets={bets} number={number} race={race} raceEntrants={raceEntrants} tickets={tickets} tournament={tournament} users={users} />

        <TablePaginationSpacer pageSize={pageSize} totalItems={myTickets.count()} />

        {selectPage(myTickets, page, pageSize).map((ticket) => <PlayFieldRaceTicket bets={bets} key={ticket.get("id")} number={number} race={race} raceEntrants={raceEntrants} ticket={ticket} tournament={tournament} />)}

        <TablePaginationSpacer pageSize={pageSize} totalItems={myTickets.count()} />
      </div>
    </div>
  );
});
